<template>
  <div class="main" :class="{'show_dialog': $store.state.dialogVisible}">
    <div class="main_content" :style="{'min-height': contentMinHeight + 'px'}">
      <z-menu></z-menu>
      <div class="main_content_box">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
      </div>
    </div>
    <div class="main_footer">
      <z-footer @footerHeight="footerHeight"></z-footer>
    </div>
  </div>
</template>

<script>
import menu from '@/components/menu/menu'
import footer from '@/components/footer/footer'

export default {
  name: 'mainIndex',
  components: {
    'z-menu': menu,
    'z-footer': footer
  },
  data() {
    return {
      contentMinHeight: 0
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {
    footerHeight(val) {
      this.contentMinHeight = window.innerHeight - val - 50
    }
  },
  watch: {}
}
</script>

<!-- scoped 设置样式只在当前组件中使用避免打包的时候样式混乱 -->
<style scoped>
.show_dialog {
  height: 100%;
  overflow: hidden;
}

.main_content {
  width: 100%;
}

.main_content_box {
  width: 1000px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 50px;
}

.main_footer {
  height: 140px;
  background-color: #505050;
}
</style>



// WEBPACK FOOTER //
// src/pages/main.vue